let DISABLE = false;
// DISABLE = true;

import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View } from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import {
  styleSheet,
  colors,
  sizes,
  mobileIncrease,
} from "app/utils/styleSheet";

import Tooltip from "app/components/Tooltip";
import Hoverable from "app/components/Hoverable";

export default class HoverableTooltip extends React.Component {
  constructor(props) {
    super(props);
    let defaultDelay = 700;
    let delay = props.delay == true ? defaultDelay : props.delay;
    this.state = {
      isHovered: false,
      stickyHovered: false,
      // stickOnClick: ENV.WEB ? this.props.stickOnClick : true,
      stickOnClick: this.props.stickOnClick,
      delay,
      delaying: false,
    };
  }

  render() {
    let { text, children, ...tooltipProps } = this.props;

    if (DISABLE)
      return (
        <View style={this.props.style}>
          {typeof children == "function" ? children() : children}
        </View>
      );

    let { isHovered, stickOnClick, stickyHovered, delay, delaying } =
      this.state;

    let Wrapper = View;
    let onPress = null;
    if (stickOnClick) {
      Wrapper = TouchableOpacity;
      onPress = () =>
        this.setState({ stickyHovered: !this.state.stickyHovered });
    }
    return (
      <View
        style={[
          styles.wrapper,
          isHovered && { zIndex: 9998 },
          this.props.style,
        ]}
      >
        <Hoverable
          delay={delay}
          onHoverIn={() => {
            this.setState({ isHovered: true });
            // if (!!delay) {
            //   this.setState({ delaying: true });
            //   this.delayTimeout = setTimeout(
            //     () => this.setState({ delaying: false }),
            //     delay
            //   );
            // }
          }}
          onHoverOut={() => {
            this.setState({ isHovered: false });
            // if (this.delayTimeout) clearTimeout(this.delayTimeout);
            // this.setState({ delaying: false });
          }}
        >
          {(inheritedIsOvered) => {
            // isHovered = true;
            if (stickyHovered) isHovered = true;
            return (
              <Wrapper onPress={onPress} style={this.props.style}>
                {typeof children == "function" ? children(isHovered) : children}

                {isHovered && !delaying && !!text && (
                  <Tooltip
                    rightAligned
                    {...tooltipProps}
                    // `style` targets this wrapper; `tooltipStyle` styles the
                    // tooltip card itself (falls back to legacy behavior)
                    style={
                      this.props.tooltipStyle !== undefined
                        ? this.props.tooltipStyle
                        : this.props.style
                    }
                  >
                    {text}
                  </Tooltip>
                )}
              </Wrapper>
            );
          }}
        </Hoverable>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    position: "relative",
    overflow: "visible",
  },
});
